import api from 'api';

export const createFinancialResult = api('POST /api/financial-results');
export const editFinancialResult = api('PUT /api/financial-results');
export const loadFinancialResults = api('POST /api/financial-results/grid');
export const downloadInvoice = api(
  'GET /api/financial-results/invoices/:id/download',
  {
    responseType: 'blob',
  }
);
export const exportAttachment = api(
  'GET /api/financial-results/attachments/:id/attachment',
  {
    responseType: 'blob',
  }
);
export const exportFinancialResults = api(
  'POST /api/financial-results/export',
  {
    responseType: 'blob',
  }
);
export const exportInvoices = api(
  'POST /api/financial-results/invoices/export'
);

export const loadSpend = api('POST /api/financial-results/spend');

export const loadFinancialResultDetails = api(
  'GET /api/financial-results/:id/details'
);
export const loadFinancialResult = api('GET /api/financial-results/:id');

export const approveFinancialResult = api(
  'POST /api/financial-results/:id/approve'
);
export const rejectFinancialResult = api(
  'POST /api/financial-results/:id/reject'
);
export const deleteFinancialResult = api(
  'POST /api/financial-results/:id/delete'
);

export const sendForApproval = api(
  'POST /api/financial-results/:id/sendforapproval'
);

export const commentFinancialResult = api(
  'POST /api/financial-results/:id/comment'
);

export const requestMoreInfo = api(
  'POST /api/financial-results/:id/requestmore'
);

export const undoFinancialResult = api('POST /api/financial-results/:id/undo');
export const uploadFile = api('PUT /api/financial-results/upload');
export const loadChart = api('GET /api/financial-results/:id/chart');

//check rename endpoint
export const loadUsersSuggestions = api('GET /api/users-suggestions');
